<template>
  <div class="row">
    <!-- Current Employment Status -->
    <div class="col-lg-6">
      <b-card header="Current Employment Status" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Current Status -->
          <div class="col-xl-6 form-group">
            <label class="form-label" for="employment_status">Current Status</label>
            <p id="employment_status">
              <span v-if="worker.rel_company_info.employment_type !== null">{{ worker.rel_company_info.employment_type.value }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Job Title -->
          <div class="col-xl-6 form-group">
            <label class="form-label" for="job_title">Job Title</label>
            <p id="job_title">
              <span
                  v-if="worker.rel_profile.job_title_id !== null && (worker.rel_profile.job_title.sector !== null && Object.keys(worker.rel_profile.job_title.sector).length > 1)">
                {{ worker.rel_profile.job_title.job_title }}
              </span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
        </div>
      </b-card>
    </div>
    <!-- CIS Tax Verification -->
    <div class="col-lg-6">
      <b-card header="CIS Tax Verification" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Verification Status -->
          <div class="col-xl-6"></div>
          <!-- Verification Details -->
          <div class="col-xl-6"></div>
        </div>
      </b-card>
    </div>
    <!-- Company / Sole Trader Information -->
    <div class="col-12" v-if="worker.rel_company_info.employment_type !== null && worker.rel_company_info.employment_type.id !== 33">
      <b-card :header="worker.rel_company_info.employment_type.value + ' Information'" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Self Employed UTR Number -->
          <div class="col-xl-3 col-lg-6 form-group">
            <label class="form-label" for="personal_utr_number">Self Employed UTR Number</label>
            <p id="personal_utr_number">
              <span v-if="worker.rel_profile.personal_utr_number !== null">{{ worker.rel_profile.personal_utr_number }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Trading Name -->
          <div class="col-xl-3 col-lg-6 form-group">
            <label class="form-label" for="company_trading_name">Trading Name</label>
            <p id="company_trading_name">
              <span v-if="worker.rel_company_info.company_trading_name !== null">{{ worker.rel_company_info.company_trading_name }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Company UTR Number -->
          <div class="col-xl-3 col-lg-6 form-group" v-if="worker.rel_company_info.employment_type.id === 32">
            <label class="form-label" for="company_utr_number">Ltd Company UTR Number</label>
            <p id="company_utr_number">
              <span v-if="worker.rel_company_info.company_utr_number !== null">{{ worker.rel_company_info.company_utr_number }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Limited Company LTD Number -->
          <div v-if="worker.rel_company_info.employment_type.id === 32" class="col-xl-3 col-lg-6 form-group">
            <label class="form-label" for="company_ltd_reg_number">LTD Registration Number</label>
            <p id="company_ltd_reg_number">
              <span v-if="worker.rel_company_info.company_ltd_reg_number !== null">{{ worker.rel_company_info.company_ltd_reg_number }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- VAT Registered -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">{{ worker.rel_company_info.employment_type.value }} VAT Registered</h5>
          </div>
          <!-- UK VAT Registered -->
          <div class="col-xl-3 col-lg-6 form-group">
            <label class="form-label" for="company_vat_registered">UK VAT Registered</label>
            <p id="company_vat_registered">
              <span v-if="worker.rel_company_info.vat_registered">Yes</span>
              <span v-else>No</span>
            </p>
          </div>
          <!-- VAT Number -->
          <div v-if="worker.rel_company_info.vat_registered" class="col-xl-3 col-lg-6 form-group">
            <label class="form-label" for="company_vat_number">VAT Number</label>
            <p id="company_vat_number">
              <span v-if="worker.rel_company_info.vat_number !== null">{{ worker.rel_company_info.vat_number }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- VAT Number Check -->
          <div v-if="worker.rel_company_info.vat_registered" class="col-lg-6 form-group">
            <div class="row" v-if="worker.rel_hmrc_vat_verification === null || Object.keys(worker.rel_hmrc_vat_verification).length === 1">
              <div class="col-lg-6">
                <h5 class="text-uppercase text-center font-weight-bold red_color">VAT Number has not been verified</h5>
              </div>
              <div class="col-lg-6">
                <button type="button" class="btn orcaBtn grey_bg sm_btn" id="check_vat_number" data-toggle="tooltip" title="Check VAT Number" @click.prevent="check_vat_number">
                  CHECK VAT NUMBER
                </button>
              </div>
              <!-- VAT Check Display -->
              <div class="col-12" v-if="notEmptyObject(vat_check) && typeof vat_check !== 'string'">
                <div class="vat_check_display mb-0" :class="vat_check.target.name !== worker.rel_company_info.company_trading_name ? 'different' : ''">
                  <div class="row">
                    <div class="col-2" v-if="vat_check.target.name !== worker.rel_company_info.company_trading_name">
                      <i class="fas fa-times"></i>
                    </div>
                    <div class="col-2" v-if="vat_check.target.name === worker.rel_company_info.company_trading_name">
                      <i class="fas fa-check"></i>
                    </div>
                    <div class="col-10">
                      <div>
                        <strong>Trading Name :</strong> <span class="vat_val">{{ vat_check.target.name }}</span>
                      </div>
                      <div>
                        <strong>Address :</strong> <span class="vat_val"><span v-for="(v, n) in vat_check.target.address" v-if="n !== 'countryCode'">
                        {{ v }}<span v-if="n !== 'postcode'">, </span></span></span>
                      </div>
                    </div>
                    <div class="col-12">
                      <p class="mb-0 font-italic">Please ensure that the address matches the address on record.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12" v-if="notEmptyObject(vat_check) && typeof vat_check === 'string'">
                <div class="vat_check_display different">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-times"></i>
                    </div>
                    <div class="col-10">
                      <div>
                        <strong>ISSUE :</strong> <span class="vat_val">{{ vat_check }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <!-- VAT Check Display -->
              <div class="col-12">
                <div class="vat_check_display mb-0" :class="worker.rel_hmrc_vat_verification.name !== worker.rel_company_info.company_trading_name ? 'different' : ''">
                  <div class="row">
                    <div class="col-2" v-if="worker.rel_hmrc_vat_verification.name !== worker.rel_company_info.company_trading_name">
                      <i class="fas fa-times"></i>
                    </div>
                    <div class="col-2" v-if="worker.rel_hmrc_vat_verification.name === worker.rel_company_info.company_trading_name">
                      <i class="fas fa-check"></i>
                    </div>
                    <div class="col-10">
                      <div>
                        <strong>Trading Name :</strong> <span class="vat_val">{{ worker.rel_hmrc_vat_verification.name }}</span>
                      </div>
                      <div>
                        <strong>Address :</strong> <span class="vat_val"><span v-for="(v, n) in JSON.parse(worker.rel_hmrc_vat_verification.address)" v-if="n !== 'countryCode'">
                        {{ v }}<span v-if="n !== 'postcode'">, </span></span></span>
                      </div>
                    </div>
                    <div class="col-12">
                      <p class="mb-0 font-italic">Please ensure that the address matches the address on record.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Company Address -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">{{ worker.rel_company_info.employment_type.value }} Company Address</h5>
          </div>
          <!-- CA Full Address -->
          <div class="col-12 form-group">
            <label class="form-label" for="company_address_full">Full Address</label>
            <p id="company_address_full"><span v-if="addresses.company.full !== null">{{ addresses.company.full }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CA Building -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_address_building">Building</label>
            <p id="company_address_building"><span v-if="addresses.company.building !== null">{{ addresses.company.building }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CA Street -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_address_street">Street</label>
            <p id="company_address_street"><span v-if="addresses.company.street !== null">{{ addresses.company.street }}</span><span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- CA Locality -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_address_locality">Locality</label>
            <p id="company_address_locality"><span v-if="addresses.company.locality !== null">{{ addresses.company.locality }}</span><span
                v-else>&nbsp;</span></p>
          </div>
          <!-- CA City/Town -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_address_city_town">City / Town</label>
            <p id="company_address_city_town"><span v-if="addresses.company.city_town !== null">{{ addresses.company.city_town }}</span><span
                v-else>&nbsp;</span>
            </p>
          </div>
          <!-- CA County -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_address_county">County</label>
            <p id="company_address_county"><span v-if="addresses.company.county !== null">{{ addresses.company.county }}</span><span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- CA Postcode -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_address_postcode">Postcode</label>
            <p id="company_address_postcode"><span v-if="addresses.company.postcode !== null">{{ addresses.company.postcode }}</span><span
                v-else>&nbsp;</span></p>
          </div>
          <!-- Company Bank Account -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">{{ worker.rel_company_info.employment_type.value }} Bank Account</h5>
          </div>
          <!-- CB Bank Name -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_bank_name">Bank Name</label>
            <p id="company_bank_name"><span v-if="banks.company.bank_name !== null">{{ banks.company.bank_name }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CB Branch Location -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_branch_location">Branch Location</label>
            <p id="company_branch_location"><span v-if="banks.company.branch_location !== null">{{ banks.company.branch_location }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CB Account Holder Name('s) -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_bank_accounts_holder">Account Holder Name('s)</label>
            <p id="company_bank_accounts_holder"><span v-if="banks.company.accounts_holder !== null">{{ banks.company.accounts_holder }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CB Account Number -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_bank_account_number">Account Number</label>
            <p id="company_bank_account_number"><span v-if="banks.company.account_number !== null">{{ banks.company.account_number }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CB Sort Code -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_sort_code">Sort Code</label>
            <p id="company_sort_code"><span v-if="banks.company.sort_code !== null">{{ banks.company.sort_code }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- CB Building Society Ref Number -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="company_bsoc_ref">Building Society Ref Number</label>
            <p id="company_bsoc_ref"><span v-if="banks.company.building_society_ref !== null">{{ banks.company.building_society_ref }}</span><span v-else>&nbsp;</span></p>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "business_info",
  props: ['worker', 'emails', 'phones', 'addresses', 'banks'],
  data() {
    return {
      // vat number check data
      vat_check: {},
    }
  },
  methods: {
    /**
     * Check VAT Number
     * -------------------------------
     * Check HMRC for VAT number entered - retrieve results
     */
    check_vat_number() {
      this.vat_check = {};
      axios.get(this.crmApiPath + 'hmrc/vat/check', {
        params: {
          vat_number: this.worker.rel_company_info.vat_number
        }
      }).then(res => {
        this.vat_check = res.data
        this.$nextTick(() => {
          let temp = {
            company_id: null,
            worker_id: this.worker.id,
            name: this.vat_check.target.name,
            vat_number: this.vat_check.target.vatNumber,
            address: JSON.stringify(this.vat_check.target.address),
            processing_date: this.vat_check.processingDate,
            log_by_type: 'App\\Models\\Users\\User',
            log_by_id: this.$store.state.auth.me.id
          }
          axios.post(this.crmApiPath + 'hmrc/vat/store', temp)
        })
      })
    },
  }
}
</script>

<style scoped>

</style>
